export class StudentMessage {
  id: string;
  messageType: string;
  message: string;
  targetUserId: string;
  date: Date;
  moduloId?: number;
}
